import React from "react";
import HomePage from "./pages/homePage";

const App = () => {
  return (
    <div>
      <HomePage />
    </div>
  );
};

export default App;
